import { Injectable } from '@angular/core';
import { FeatureFlagsRulesService, Http, QueryBus, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { SaleDocumentRepositoryBase } from '@skylab-shared/business';
import { ClientRepository } from '../client/client.repo';
import { ProductRepository } from '../product/product.repo';
export { SaleDocumentRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(SaleDocumentRepositoryBase)
export class SaleDocumentRepository {
    public constructor(
        http: Http,
        weaver: Weaver,
        productRepository: ProductRepository,
        clientRepository: ClientRepository,
        queryBus: QueryBus,
        featureFlagsRulesService: FeatureFlagsRulesService
    ) { }
}
